// Manage Code Context
export const SET_MANAGE_CODE = 'SET_MANAGE_CODE';
export const RESET_MANAGE_CODE = 'RESET_MANAGE_CODE';